<!-- Separator -->
<div class="hidden lg:block lg:h-6 w-px bg-gray-900/10 lg:hidden" aria-hidden="true"></div>

<div class="flex flex-1 items-center justify-between gap-x-4 self-stretch lg:gap-x-6">
  <!-- Left side - Stats and navigation (hidden in koncern mode) -->
  <div class="flex-1 flex items-center space-x-2 max-w-4xl">
    @if (!isKoncernMode()) {
    @if (subscribesToCatalogue() && !currentUser()?.is_guest) {
      <div (click)="goToCatalogue()" class="hidden md:flex items-center bg-white/80 backdrop-blur-sm rounded-lg px-3 py-2 cursor-pointer font-medium shadow-sm hover:shadow-md transition-all duration-200 hover:bg-white/90 border border-blue-200/50">
        <span class="hidden lg:block text-gray-700 font-semibold text-sm">{{"SUBSCRIPTION_CATALOGUE" | translate}}:</span>
        <span class="bg-blue-100 text-blue-700 px-2 py-0.5 rounded-full text-xs font-bold">{{cataloguesCount()}}</span>
      </div>
    }
    @if (subscribesToProducts() && !currentUser()?.is_printer && !currentUser()?.is_guest) {
      <div (click)="goToProducts()" class="hidden md:flex items-center bg-white/80 backdrop-blur-sm rounded-lg px-3 py-2 cursor-pointer font-medium shadow-sm hover:shadow-md transition-all duration-200 hover:bg-white/90 border border-blue-200/50">
        <span class="hidden lg:block text-gray-700 font-semibold text-sm"
              title="{{'SWEDISH' | translate}}: {{productsLang.sv}}{{'\n'}}{{'ENGLISH' | translate}}: {{productsLang.en}}{{'\n'}}{{'FINNISH' | translate}}: {{productsLang.fi}}">
          {{"PRODUCTS" | translate}}:
        </span>
        <span class="hidden lg:block bg-green-100 text-blue-700 px-2 py-0.5 rounded-full text-xs font-bold">{{productsCount()}}</span>
      </div>
    }
    @if (subscribesToCoordinator() && !currentUser()?.is_guest && currentUser() && isAdmin()) {
      <div (click)="goToCoordinator()" class="hidden md:flex items-center bg-white/80 backdrop-blur-sm rounded-lg px-3 py-2 cursor-pointer font-medium shadow-sm hover:shadow-md transition-all duration-200 hover:bg-white/90 border border-blue-200/50">
        <span class="hidden lg:block text-gray-700 font-semibold text-sm">{{"COORDINATOR_SHORT" | translate}}:</span>
        <span class="bg-purple-100 text-blue-700 px-2 py-0.5 rounded-full text-xs font-bold">{{coordinatorCount()}}</span>
      </div>
    }
    @if (subscribesToSubstitution() && !currentUser()?.is_guest && currentUser() && isAdmin()) {
      <div (click)="goToSubstitution()" class="hidden md:flex items-center bg-white/80 backdrop-blur-sm rounded-lg px-3 py-2 cursor-pointer font-medium shadow-sm hover:shadow-md transition-all duration-200 hover:bg-white/90 border border-blue-200/50">
        <span class="hidden lg:block text-gray-700 font-semibold text-sm">{{"SUBSTITUTION" | translate}}:</span>
        <span class="bg-orange-100 text-blue-700 px-2 py-0.5 rounded-full text-xs font-bold">{{substitutionCount()}}</span>
      </div>
    }
    @if (subscribesToRiskAssessment() && !currentUser()?.is_guest && currentUser() && isAdmin()) {
      <div (click)="gotoLocalRiskAssessments()" class="hidden md:flex items-center bg-white/80 backdrop-blur-sm rounded-lg px-3 py-2 cursor-pointer font-medium shadow-sm hover:shadow-md transition-all duration-200 hover:bg-white/90 border border-blue-200/50"
           title="{{'LOCAL_RISK_ASSESSMENT' | translate}}">
        <span class="hidden lg:block text-gray-700 font-semibold text-sm">LRB:</span>
        <span class="bg-red-100 text-blue-700 px-2 py-0.5 rounded-full text-xs font-bold">{{lrbCount()}}</span>
      </div>
    }
    @if (subscribesToRiskAssessment() && !currentUser()?.is_guest && !currentUser()?.is_printer) {
      <div (click)="gotoActivityRiskAssessments()" class="hidden md:flex items-center bg-white/80 backdrop-blur-sm rounded-lg px-3 py-2 cursor-pointer font-medium shadow-sm hover:shadow-md transition-all duration-200 hover:bg-white/90 border border-blue-200/50"
           title="{{'ACTIVITY_RISK_ASSESSMENTS' | translate}}">
        <span class="hidden lg:block text-gray-700 font-semibold text-sm">ARB:</span>
        <span class="bg-yellow-100 text-blue-700 px-2 py-0.5 rounded-full text-xs font-bold">{{arbCount()}}</span>
      </div>
    }
    }
  </div>

  <!-- Right side items -->
  <div class="flex items-center gap-x-4 lg:gap-x-6">
    <!-- Notifications button -->
    <button type="button" class="relative hidden md:inline-flex p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors duration-200">
      <span class="sr-only">View notifications</span>
      <svg class="size-5" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true" data-slot="icon">
        <path stroke-linecap="round" stroke-linejoin="round" d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0" />
      </svg>
      <!-- Notification badge -->
      <!--<span class="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">3</span>-->
    </button>

    <!-- Website Link (compact) -->
    <a
      href="https://kemikaliedokumentation.se/"
      target="_blank"
      rel="noopener noreferrer"
      class="hidden md:inline-flex items-center gap-1.5 px-2 py-1 text-xs font-medium
            text-blue-600 hover:text-blue-700 bg-white/60 hover:bg-blue-50
            border border-blue-200/60 rounded-md shadow-sm transition-colors
            focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-400/40
            whitespace-nowrap"
      aria-label="Open website in a new tab"
      >
      <!-- External-link icon (tiny) -->
      <svg class="size-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round"
              d="M13.5 6H18a.75.75 0 0 1 .75.75V11.25M10.5 13.5 18 6M15.75 12.75v4.5a.75.75 0 0 1-.75.75h-9a.75.75 0 0 1-.75-.75v-9a.75.75 0 0 1 .75-.75h4.5"/>
      </svg>

      <span class="hidden lg:inline">www.cdoc.se</span>
      <span class="lg:hidden">{{ 'WEBSITE' | translate }}</span>
    </a>

    <!-- Separator -->
    <div class="hidden lg:block lg:h-6 lg:w-px lg:bg-gray-300" aria-hidden="true"></div>

    <!-- Profile dropdown -->
    <div class="relative">
      <button type="button"
              (click)="toggleSettingsDropdown()"
              class="relative flex items-center gap-x-3 rounded-full bg-white/80 backdrop-blur-sm text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 shadow-sm hover:shadow-md transition-all duration-200 px-1.5 py-1 min-[1600px]:px-3 border border-blue-200/50"
              id="user-menu-button"
              [attr.aria-expanded]="isSettingsDropdownOpen()"
              aria-haspopup="true">
        <span class="sr-only">Open user menu</span>
        <svg class="size-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" d="M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
        </svg>
        <span class="hidden min-[1600px]:flex min-[1600px]:items-center">
          <span class="text-sm font-semibold text-gray-900 whitespace-nowrap" aria-hidden="true">
            {{ ((currentUser()?.first_name || '').trim()
                ? (currentUser()?.first_name + ' ' + (currentUser()?.last_name || '')).trim()
                : (currentUser()?.username || '') ) }}
          </span>
          <svg class="ml-2 size-4 text-gray-500 transition-transform duration-200"
               [class.rotate-180]="isSettingsDropdownOpen()"
               viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
            <path fill-rule="evenodd" d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
          </svg>
        </span>
      </button>

      <!--
        Dropdown menu, show/hide based on menu state.

        Entering: "transition ease-out duration-100"
          From: "transform opacity-0 scale-95"
          To: "transform opacity-100 scale-100"
        Leaving: "transition ease-in duration-75"
          From: "transform opacity-100 scale-100"
          To: "transform opacity-0 scale-95"
      -->
      @if (isSettingsDropdownOpen()) {
        <div class="absolute right-0 z-10 mt-2.5 w-48 origin-top-right rounded-lg bg-white/95 backdrop-blur-sm py-2 shadow-xl ring-1 ring-gray-900/5 focus:outline-hidden border border-blue-200/50"
            role="menu"
            aria-orientation="vertical"
            aria-labelledby="user-menu-button"
            tabindex="-1">
          <!-- Active: "bg-gray-50 outline-hidden", Not Active: "" -->
          @if (!currentUser()?.is_guest) {
            <a (click)="goToHelp()" class="cursor-pointer block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 transition-colors duration-150" role="menuitem" tabindex="-1" id="user-menu-item-0">
              <div class="flex items-center">
                <svg class="mr-3 size-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z" />
                </svg>
                {{"HELP" | translate}}
              </div>
            </a>
          }
          @if (!currentUser()?.is_guest) {
            <a (click)="goToSettings()" class="cursor-pointer block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 transition-colors duration-150" role="menuitem" tabindex="-1" id="user-menu-item-1">
              <div class="flex items-center">
                <svg class="mr-3 size-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 6h9.75M10.5 6a1.5 1.5 0 1 1-3 0m3 0a1.5 1.5 0 1 0-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-9.75 0h9.75" />
                </svg>
                {{"SETTINGS" | translate}}
              </div>
            </a>
          }
          @if (!currentUser()?.is_guest) {
            <a (click)="showContactForm()" class="cursor-pointer block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 transition-colors duration-150" role="menuitem" tabindex="-1" id="user-menu-item-2">
              <div class="flex items-center">
                <svg class="mr-3 size-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M16.712 4.33a9.027 9.027 0 0 1 1.652 1.306c.51.51.944 1.064 1.306 1.652M16.712 4.33l-3.448 4.138m3.448-4.138a9.014 9.014 0 0 0-9.424 0M19.67 7.288l-4.138 3.448m4.138-3.448a9.014 9.014 0 0 1 0 9.424m-4.138-5.976a3.736 3.736 0 0 0-.88-1.388 3.737 3.737 0 0 0-1.388-.88m2.268 2.268a3.765 3.765 0 0 1 0 2.528m-2.268-4.796a3.765 3.765 0 0 0-2.528 0m4.796 4.796c-.181.506-.475.982-.88 1.388a3.736 3.736 0 0 1-1.388.88m2.268-2.268 4.138 3.448m0 0a9.027 9.027 0 0 1-1.306 1.652c-.51.51-1.064.944-1.652 1.306m0 0-3.448-4.138m3.448 4.138a9.014 9.014 0 0 1-9.424 0m5.976-4.138a3.765 3.765 0 0 1-2.528 0m0 0a3.736 3.736 0 0 1-1.388-.88 3.737 3.737 0 0 1-.88-1.388m2.268 2.268L7.288 19.67m0 0a9.024 9.024 0 0 1-1.652-1.306 9.027 9.027 0 0 1-1.306-1.652m0 0 4.138-3.448M4.33 16.712a9.014 9.014 0 0 1 0-9.424m4.138 5.976a3.765 3.765 0 0 1 0-2.528m0 0c.181-.506.475-.982.88-1.388a3.736 3.736 0 0 1 1.388-.88m-2.268 2.268L4.33 7.288m6.406 1.18L7.288 4.33m0 0a9.024 9.024 0 0 0-1.652 1.306A9.025 9.025 0 0 0 4.33 7.288" />
                </svg>
                Support
              </div>
            </a>
          }
          <a (click)="logout()" class="cursor-pointer block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 transition-colors duration-150" role="menuitem" tabindex="-1" id="user-menu-item-3">
            <div class="flex items-center">
              <svg class="mr-3 size-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15M12 9l-3 3m0 0 3 3m-3-3h12.75" />
              </svg>
              {{"LOGOUT" | translate}}
            </div>
          </a>
        </div>
      }
    </div>
  </div>
</div>
